import React from 'react';
import { Link } from 'react-router-dom';

const GamesMoviesModal = ({ isOpen, movieColumns, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/70 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="movies-modal-title"
    >
      <div className="w-full max-w-2xl rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-50 via-white to-blue-50 shadow-2xl shadow-slate-900/20">
        <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-5">
          <div>
            <p className="text-sm font-semibold text-sky-700">MVP em andamento</p>
            <h2 id="movies-modal-title" className="mt-2 text-2xl font-semibold text-gray-900">
              Nova area de filmes
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md px-3 py-2 text-sm font-medium text-gray-500 hover:bg-slate-100 hover:text-gray-700"
            aria-label="Fechar modal"
          >
            Fechar
          </button>
        </div>

        <div className="px-6 py-6">
          <p className="text-gray-600">
            A nova pagina organiza listas como filmes favoritos, filmes ja assistidos e titulos que
            voce ainda quer ver. Comeca simples, no mesmo padrao visual do site, e fica pronta para
            receber integracao com API depois.
          </p>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            {movieColumns.map((column) => (
              <div
                key={column.id}
                className="rounded-lg border border-slate-200 bg-slate-100/70 site-card-soft p-4"
              >
                <p className="font-semibold text-gray-900">{column.title}</p>
                <p className="mt-2 text-sm text-gray-600">{column.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center justify-center rounded-md border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-100"
            >
              Continuar no Laboratorio
            </button>
            <Link
              to="/laboratorio/filmes"
              onClick={onClose}
              className="inline-flex items-center justify-center rounded-md bg-slate-800 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
            >
              Abrir pagina de filmes
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GamesMoviesModal;
